import { CardDescription, CardHeader, CardTitle } from '@bpinternal/ui-kit-next'
import { useState, type FC } from 'react'
import { formatters } from '../../../utils'
import { QUOTA_TYPE_USER_FACING_PROPERTIES_MAP } from '../constants'

export type SpendType = 'total' | 'daily'
type Props = {
  totalAiSpend: number
  averageAiSpendPerDay: number
  onActiveChartChange?: (type: SpendType) => void
  title?: string
  description?: string
}

export const DailySpendChartHeader: FC<Props> = ({
  totalAiSpend,
  averageAiSpendPerDay,
  onActiveChartChange,
  title,
  description,
}) => {
  const [activeChart, setActiveChart] = useState<SpendType>('total')

  const handleActiveChartChange = (type: SpendType) => {
    setActiveChart(type)
    onActiveChartChange?.(type)
  }

  const spends: Record<SpendType, { value: number; label: string }> = {
    total: {
      value: totalAiSpend,
      label: 'Total',
    },
    daily: {
      value: averageAiSpendPerDay,
      label: 'Daily Average',
    },
  }

  return (
    <CardHeader className="flex flex-col items-stretch space-y-0 border-b p-0 sm:flex-row">
      <div className="flex flex-1 flex-col justify-center gap-1 px-6 py-5 sm:py-6">
        <CardTitle>{title ?? QUOTA_TYPE_USER_FACING_PROPERTIES_MAP['ai_spend'].name}</CardTitle>
        <CardDescription>
          {description ?? QUOTA_TYPE_USER_FACING_PROPERTIES_MAP['ai_spend'].description}
        </CardDescription>
      </div>
      <div className="flex">
        {Object.keys(spends).map((key) => {
          const typeKey = key as keyof typeof spends
          return (
            <button
              key={key}
              data-active={activeChart === typeKey}
              className="flex flex-1 flex-col justify-center gap-1 border-t px-6 py-4 text-left even:border-l data-[active=true]:bg-muted/50 sm:border-l sm:border-t-0 sm:px-8 sm:py-6"
              onClick={() => handleActiveChartChange(typeKey)}
            >
              <span className="text-xs text-muted-foreground">{spends[typeKey].label}</span>
              <span className="text-lg font-bold leading-none sm:text-3xl">
                {formatters.$nanodollars(spends[typeKey].value)}
              </span>
            </button>
          )
        })}
      </div>
    </CardHeader>
  )
}
